// Generated via oats. Do NOT modify manually.

import * as t from 'io-ts';
import {excess} from '@fl/cmsch-fe-library';

// @ts-ignore: Workaround for "is declared but its value is never read."
import { AbstractTableFilter, AbstractTableFilterSchema } from 'api/gen/AbstractTableFilter';

const requiredPart = t.interface({
  tag: t.literal('GREATER_THAN_DECIMAL'),
  field: t.string,
  value: t.number,
});

export const GreaterThanDecimalFilterSchema = excess(t.intersection([AbstractTableFilterSchema.type, requiredPart]));

export interface GreaterThanDecimalFilter extends t.TypeOf<typeof GreaterThanDecimalFilterSchema> {}
